/* eslint-disable camelcase */
// import core & vendor packages below
import { useDispatch } from 'react-redux';
import Popover from 'react-bootstrap/Popover';
import React, { useState, useEffect } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Form, Row, Col, FormControl, Button, Modal, Accordion } from 'react-bootstrap';

// import components below
import Moment from 'moment';
import FormUI from 'components/UI/FormUI';
import Table from 'components/ReactTable';
import { approverequesteditem } from 'reducers/refillRequest';

// import assets below
import './modal.scss';
import { ReactComponent as CircleXMark } from 'assets/svg/circle-xmark.svg';
import { ReactComponent as CirleMinusSVG } from 'assets/svg/circle-minus.svg';
import { ReactComponent as CircleCheck } from 'assets/svg/circle-check-green.svg';

// main component
const ViewRequestModal = ({
  showProfile,
  setShowProfile,
  setState,
  state,
  items,
  setTrigger,
  groups,
}) => {
  // Redux
  const dispatch = useDispatch();

  const { item_list, filtered_item_list } = state;

  const [enteredSearch, setEnteredSearch] = useState('');
  const [groupchange, setGroupchange] = useState('');

  // Get group name from included api
  const getGroupName = (id) => {
    const selectedArray = items.filter((data) => data.id === id && data.type === 'groups');

    if (selectedArray.length === 0) {
      return 'N/A';
    }

    return selectedArray[0]?.attributes?.name;
  };

  // approve item
  const approveItem = () => {
    setShowProfile((prev) => {
      return { ...prev, isAcceptModal: true, isShowViewRequestModal: false };
    });
  };

  const actionClickHandler = (eventKey, id) => {
    const action = {
      approve: () => {
        const params = {
          restock_id: state?.itemID?.id,
          requested_item: id,
          url: 'approve',
        };
        dispatch(approverequesteditem(params));
        setTrigger((prev) => {
          return { ...prev, approverequesteditemTrigger: true };
        });
      },
      deny: () => {
        setShowProfile((prev) => {
          return { ...prev, isShowDenyItemModal: true, isShowViewRequestModal: false };
        });
        setState((prev) => {
          return { ...prev, requested_item_id: id };
        });
      },
    };
    action[eventKey]();
  };

  // table action handler
  const actionHandler = (id, status) => {
    return (
      <div>
        {status === 'new' ? (
          <div>
            <CircleCheck
              onClick={() => {
                actionClickHandler('approve', id);
              }}
              style={{
                fill: '#01B425',
                width: '2em',
                cursor: 'pointer',
                margin: '2px',
              }}
            />
            <CirleMinusSVG
              onClick={() => {
                actionClickHandler('deny', id);
              }}
              style={{
                fill: '#01B425',
                width: '2em',
                cursor: 'pointer',
                margin: '2px',
              }}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  };
  const statusAction = (remark, status) => (
    <>
      {status === 'new' && (
        <span
          className='px-3 py-1 text-white'
          style={{ backgroundColor: '#00a8ff', borderRadius: '5px' }}
        >
          {status}
        </span>
      )}
      {status === 'approved' && (
        <span
          className='px-3 py-1 text-white'
          style={{ backgroundColor: '#20C997', borderRadius: '5px' }}
        >
          {status}
        </span>
      )}
      {status === 'denied' &&
        (remark ? (
          <OverlayTrigger
            placement='right'
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Popover>
                <Popover.Header as='h3' style={{ backgroundColor: '#03A8FF', color: 'white' }}>
                  Remark
                </Popover.Header>
                <Popover.Body>{remark}</Popover.Body>
              </Popover>
            }
          >
            <Button
              className='px-3 py-1 text-white'
              style={{ backgroundColor: '#ff0000', borderRadius: '5px' }}
            >
              {status}
            </Button>
          </OverlayTrigger>
        ) : (
          <Button
            className='px-3 py-1 text-white'
            style={{ backgroundColor: '#ff0000', borderRadius: '5px' }}
          >
            {status}
          </Button>
        ))}
      {status === 'completed' && (
        <span
          className='px-3 py-1 text-white'
          style={{ backgroundColor: '#02961C', borderRadius: '5px' }}
        >
          {status}
        </span>
      )}
      {status !== 'new' && status !== 'approved' && status !== 'completed' && status !== 'denied' && (
        <span
          className='px-3 py-1 text-white'
          style={{ backgroundColor: '#0069F2', borderRadius: '5px' }}
        >
          {status}
        </span>
      )}
    </>
  );

  const tableColumns = React.useMemo(
    () =>
      state.itemID?.attributes?.status === 'approved' ||
      state.itemID?.attributes?.status === 'in progress' ||
      state.itemID?.attributes?.status === 'for approval'
        ? [
            { Header: 'Item Code', accessor: 'item_code' }, // accessor is the "key" in the data
            { Header: 'Item Name', accessor: 'item_name' },
            { Header: 'Item Group', accessor: 'item_group' },
            { Header: 'Storage Bin', accessor: 'storage_bin' },
            { Header: 'Onhand ', accessor: 'quantity' },
            { Header: 'Requested Quantity', accessor: 'requested_quantity' },
            { Header: 'UOM', accessor: 'uom' },
            { Header: 'Status', accessor: 'status' },
            { Header: 'Action', accessor: 'action' },
          ]
        : [
            { Header: 'Item Code', accessor: 'item_code' }, // accessor is the "key" in the data
            { Header: 'Item Name', accessor: 'item_name' },
            { Header: 'Item Group', accessor: 'item_group' },
            { Header: 'Storage Bin', accessor: 'storage_bin' },
            { Header: 'Onhand ', accessor: 'quantity' },
            { Header: 'Requested Quantity', accessor: 'requested_quantity' },
            { Header: 'UOM', accessor: 'uom' },
            { Header: 'Status', accessor: 'status' },
          ],
    [state?.itemID],
  );

  const tableData = React.useMemo(
    () =>
      filtered_item_list
        ? filtered_item_list?.map((dd) => ({
            id: dd?.id,
            item_code: dd?.attributes?.code,
            item_name: dd?.attributes?.name,
            item_group: getGroupName(dd?.relationships?.group?.data[0].id),
            storage_bin: dd?.attributes?.storage_bin,
            quantity: dd?.attributes?.quantity,
            requested_quantity: dd?.quantity,
            uom: dd?.attributes?.unit_of_measure,
            status: statusAction(dd?.remarks, dd?.status),
            action: actionHandler(dd?.restock_id, dd?.status),
          }))
        : null,
    [filtered_item_list],
  );
  useEffect(() => {
    const identifier = setTimeout(() => {
      // store temporary the item list
      let filtered_item_list = item_list;
      // filter item list
      if (enteredSearch !== '') {
        filtered_item_list = item_list.filter(
          (data) =>
            data.attributes.code === enteredSearch || data.attributes.name === enteredSearch,
        );

        setState((prev) => {
          return { ...prev, filtered_item_list: filtered_item_list };
        });
      }

      // return the original item list
      if (enteredSearch === '') {
        setState((prev) => {
          return { ...prev, filtered_item_list: filtered_item_list };
        });
      }
    }, 500);

    return () => {
      clearTimeout(identifier);
    };
  }, [enteredSearch]);

  useEffect(() => {
    // store temporary the item list
    let filtered_item_list = item_list;
    if (groupchange !== '') {
      filtered_item_list = item_list.filter((data) => {
        const groupID = data.relationships.group.data[0].id;
        return groupID === groupchange;
      });

      setState((prev) => {
        return { ...prev, filtered_item_list: filtered_item_list };
      });
    }
    // return the original item list
    if (groupchange === '') {
      setState((prev) => {
        return { ...prev, filtered_item_list: filtered_item_list };
      });
    }
  }, [groupchange]);
  return (
    <Modal
      size='lg'
      show={showProfile?.isShowViewRequestModal}
      onHide={() => {
        setShowProfile((prevState) => {
          return {
            ...prevState,
            isShowViewRequestModal: false,
          };
        });
      }}
      aria-labelledby='Request Item Modal'
      className='department-inventory request-item'
    >
      <Modal.Body>
        <div className='department-inventory-header'>
          <div className='d-flex header'>
            <p>REQUEST Details</p>

            <CircleXMark
              style={{ width: '2em', cursor: 'pointer' }}
              onClick={() =>
                setShowProfile((prevState) => {
                  return {
                    ...prevState,
                    isShowViewRequestModal: false,
                  };
                })
              }
            />
          </div>
        </div>

        <FormUI>
          <Form className='add-item-form'>
            <Row>
              <Col>
                <div>
                  <Row>
                    <Col className='request-details'>
                      <Form.Group className='inline-group'>
                        <Form.Label>Request Date/Time :</Form.Label>
                        <span className='ms-5'>
                          {Moment(state?.itemID?.attributes?.requested_at).format(
                            'MMMM Do YYYY, h:mm:ss a',
                          )}
                        </span>
                      </Form.Group>
                      <Form.Group className='inline-group'>
                        <Form.Label>Request No.</Form.Label>
                        <span className='ms-5'>{state?.itemID?.attributes?.request_number}</span>
                      </Form.Group>
                    </Col>
                    <Col className='text-end'>
                      <Form.Group>
                        <Form.Label>Request By :</Form.Label>
                        <span className='ms-5 fw-bold' style={{ color: '#006397' }}>
                          {state?.itemID?.attributes?.requested_by}
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                <div className='search-item'>
                  <Accordion className='advanced-search' defaultActiveKey={'0'}>
                    <Accordion.Item eventKey='0'>
                      <Accordion.Header>Items</Accordion.Header>
                      <Accordion.Body>
                        <Row>
                          <Col sm={6}>
                            <Row>
                              <Col>
                                <Form.Group>
                                  <Form.Label>Item Code/Name</Form.Label>
                                  <FormControl
                                    type='text'
                                    onChange={(e) => setEnteredSearch(e.target.value)}
                                    className='bg-white'
                                    placeholder='Search '
                                  />
                                </Form.Group>
                              </Col>
                              <Col>
                                <Form.Group>
                                  <Form.Label>Sort By</Form.Label>
                                  <Form.Select
                                    value={groupchange}
                                    onChange={(e) => setGroupchange(e.target.value)}
                                  >
                                    <option value=''>Item Group</option>
                                    {groups?.map((data) => (
                                      <option key={data.id} value={data.id}>
                                        {data.attributes.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>

                <div className='search-table mb-4'>
                  <Table data={tableData} columns={tableColumns} pagination={['BOTTOM']} />

                  <Row>
                    <Col>
                      <Form.Group className='mt-4 buttons-cont'>
                        {state?.itemID?.attributes?.status === 'for approval' && (
                          <>
                            <Button className='add-button' variant='primary' onClick={approveItem}>
                              Submit / Approve
                            </Button>
                            <Button
                              onClick={() => {
                                setShowProfile((prevState) => {
                                  return {
                                    ...prevState,
                                    isShowViewRequestModal: false,
                                    isDenyModal: true,
                                  };
                                });
                              }}
                              className='clear-button bg-danger'
                            >
                              Reject All
                            </Button>
                          </>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Form>
        </FormUI>
      </Modal.Body>
    </Modal>
  );
};

export default ViewRequestModal;
